import clsx from 'clsx';

import {Paragraph} from '@/modules/foundation/components/typography/paragraph';
import type {BlockquoteFragment} from '@/modules/foundation/sanity/portable-text/blockquote/query';

type Props = {
	quote: BlockquoteFragment['quote'];
	source: BlockquoteFragment['source'];
};

export const Blockquote = ({quote, source}: Props) => {
	return (
		<blockquote
			className={clsx(
				'my-8',
				'text-grey-8',
				'bg-warning-95',
				'rounded-lg',
				'p-4',
				'md:p-8',
				'flex',
				'gap-6',
			)}
		>
			<svg
				xmlns="http://www.w3.org/2000/svg"
				width="24"
				height="25"
				viewBox="0 0 24 25"
				fill="none"
				className="shrink-0"
			>
				<path
					d="M9.93054 4.85193C8.65438 4.88816 7.39788 5.1757 6.23297 5.69809C5.06806 6.22048 4.01759 6.96747 3.1417 7.8963C2.26581 8.82513 1.58169 9.91758 1.12849 11.1111C0.675285 12.3046 0.4619 13.5758 0.500543 14.8519V16.0919C0.500543 17.069 0.790269 18.0241 1.33308 18.8364C1.8759 19.6488 2.64742 20.282 3.55009 20.6559C4.45275 21.0298 5.44602 21.1276 6.40429 20.937C7.36256 20.7464 8.24278 20.2759 8.93365 19.585C9.62452 18.8942 10.095 18.0139 10.2856 17.0557C10.4762 16.0974 10.3784 15.1041 10.0045 14.2015C9.63061 13.2988 8.99744 12.5273 8.18506 11.9845C7.37268 11.4417 6.41758 11.1519 5.44054 11.1519C5.06616 11.1522 4.69328 11.1993 4.33054 11.2919C4.28321 11.3054 4.23287 11.304 4.18637 11.2879C4.13986 11.2718 4.09942 11.2418 4.07054 11.2019C4.04383 11.1601 4.02963 11.1115 4.02963 11.0619C4.02963 11.0123 4.04383 10.9637 4.07054 10.9219C4.64551 9.86278 5.49048 8.97461 6.51968 8.34761C7.54888 7.72061 8.72566 7.37709 9.93054 7.35193C10.2621 7.35193 10.58 7.22023 10.8144 6.98581C11.0488 6.75139 11.1805 6.43345 11.1805 6.10193C11.1805 5.77041 11.0488 5.45247 10.8144 5.21804C10.58 4.98362 10.2621 4.85193 9.93054 4.85193Z"
					fill="#EC7B6E"
				/>
				<path
					d="M22.2509 7.35193C22.5824 7.35193 22.9003 7.22023 23.1347 6.98581C23.3692 6.75139 23.5009 6.43345 23.5009 6.10193C23.5009 5.77041 23.3692 5.45247 23.1347 5.21804C22.9003 4.98362 22.5824 4.85193 22.2509 4.85193C20.9747 4.88816 19.7182 5.1757 18.5533 5.69809C17.3884 6.22048 16.3379 6.96747 15.462 7.8963C14.5861 8.82513 13.902 9.91758 13.4488 11.1111C12.9956 12.3046 12.7822 13.5758 12.8209 14.8519V16.0919C12.8189 17.0718 13.1078 18.0302 13.6509 18.8458C14.1941 19.6613 14.967 20.2973 15.8719 20.6732C16.7769 21.0491 17.773 21.148 18.7341 20.9573C19.6952 20.7666 20.5782 20.295 21.271 19.6021C21.9639 18.9092 22.4355 18.0263 22.6262 17.0652C22.8169 16.104 22.718 15.1079 22.3421 14.203C21.9662 13.2981 21.3302 12.5251 20.5147 11.982C19.6991 11.4388 18.7407 11.15 17.7609 11.1519C17.3865 11.1529 17.0137 11.1999 16.6509 11.2919C16.6035 11.3054 16.5532 11.304 16.5067 11.2879C16.4602 11.2718 16.4197 11.2418 16.3909 11.2019C16.3641 11.1601 16.3499 11.1115 16.3499 11.0619C16.3499 11.0123 16.3641 10.9637 16.3909 10.9219C16.9658 9.86278 17.8108 8.97461 18.84 8.34761C19.8692 7.72061 21.046 7.37709 22.2509 7.35193Z"
					fill="#EC7B6E"
				/>
			</svg>
			<div className={clsx('flex', 'flex-col', 'gap-2')}>
				<Paragraph size="md" asChild>
					<span>{quote}</span>
				</Paragraph>
				<Paragraph size="xs" asChild>
					<span>{source}</span>
				</Paragraph>
			</div>
		</blockquote>
	);
};
